import { computed, DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, merge, fromEvent,  map, distinctUntilChanged, shareReplay, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  private readonly destroyRef = inject(DestroyRef);
  
  // Signal privado para el estado interno
  private readonly _isOnline = signal<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  
  // Signal público de solo lectura
  public readonly isOnline = this._isOnline.asReadonly();
  
  // Computed signal para estado como string
  public readonly connectionStatus = computed(() => 
    this.isOnline() ? 'online' : 'offline'
  );

  // Observable original para compatibilidad con otras páginas
  public readonly online$: Observable<boolean>;

  constructor() {
    this.online$ = merge(
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false))
    ).pipe(
      startWith(navigator.onLine),
      distinctUntilChanged(),
      shareReplay(1)
    );

    this.syncSignalWithObservable();
  }

  private syncSignalWithObservable(): void {
    this.online$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(isOnline => {
        this._isOnline.set(isOnline);
      });
  }
}
